import React from 'react';

const Footer = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="copyright">
          &copy; Copyright <strong><span> 2024</span></strong>. All Rights Reserved
        </div>
        <div className="credits">
          <b>Designed by Adarsh Mishra</b>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
